import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes, faBars } from '@fortawesome/free-solid-svg-icons';
import '../styles.css';

function Header({ onToggleClick, isSidebarVisible, showToggleIcon = true }) {
  return (
    <nav className="app-header">
      <div className="header-container">
        <a className="header-brand">
          <img src="/Teamhalt.png" alt="TeamHalt" className="header-logo" />
          <div className="header-brand-text">
            <span className="brand-name">TeamHalt</span>
            <span className="brand-tagline">Attendance</span>
          </div>
        </a>
        {showToggleIcon && (
          <button 
            className="header-toggle" 
            onClick={onToggleClick}
            aria-label={isSidebarVisible ? "Close sidebar" : "Open sidebar"}
          >
            <FontAwesomeIcon icon={isSidebarVisible ? faTimes : faBars} />
          </button>
        )}
      </div>
    </nav>
  );
}

export default Header;

